var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<leaflet id=\"mymap\" lf-center=\"$ctrl.center\" geojson=\"$ctrl.geojson\" layers=\"$ctrl.layers\" markers=\"$ctrl.markers\" width=\"100%\" height=\"480px\"></leaflet><div><input type=\"text\" ng-model=\"$ctrl.query.criteria.ZipCode\"/> <button ng-click=\"$ctrl.goToZip()\">Go</button></div><button ng-click=\"$ctrl.search()\">Search this area</button><br><button ng-click=\"$ctrl.findMe()\">Go to my location</button>";
var id1="map-customer.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;